module.exports = __webpack_public_path__ + "img/feature_buy_zh.2df8b181.png";